import { EntitiesTab as Component } from './components';
import Connector from './connector';
import { ConnectorProps } from './EntitiesTab.proptype';

export interface EntitiesTabProps extends Omit<ConnectorProps, 'component'> {}

export const EntitiesTab = (props: EntitiesTabProps) => <Connector {...props} component={Component} />;
